import React from "react";
import { useNavigate } from 'react-router-dom';


export const NavAccount = () => {
  const navigate = useNavigate();

  return (
    <a className="flex items-center gap-2 cursor-pointer" onClick={() => navigate("/profile")}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6 text-grey-400 hover:text-gray-100">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
        </svg>
    </a>
  );
};
